import React from "react";
import { useTranslation } from "react-i18next";
import i18n from "@/locale/i18n";
import _supportedLocales from "@/locale/supportedLocales";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLanguage } from "@fortawesome/free-solid-svg-icons";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface Props {
  className?: string;
  btnClassName?: string;
}

export default function LocaleSelector({ className, btnClassName }: Props) {
  const { t } = useTranslation();
  const supportedLocales = _supportedLocales;
  const currentLanguage = i18n.language;

  function select(value: string) {
    localStorage.setItem("locale", value);
    i18n.changeLanguage(value);
  }

  return (
    <div className={className}>
      <Select defaultValue={currentLanguage} onValueChange={select}>
        <SelectTrigger className="w-auto min-w-9 px-2">
          <FontAwesomeIcon
            icon={faLanguage}
            aria-label={t("settings.preferences.language")}
            className="text-lg"
          />
        </SelectTrigger>
        <SelectContent>
          {supportedLocales.map((language) => (
            <SelectItem key={language.lang} value={language.lang}>
              {t("shared.locales." + language.lang)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
